import type { StoreSupportContact } from '@/api/endpoints'

const digitsOnly = (s: string) => s.replace(/\D/g, '')

/** Ссылка `tel:` для номера из поля магазина (`store.phones`). */
export function rawPhoneHref(phone: string): string {
  const v = phone.trim()
  const d = digitsOnly(v)
  return d ? `tel:${d}` : `tel:${encodeURIComponent(v)}`
}

/** Ссылка для контакта: приоритет `url` с бэка, иначе строим по `contact_type`. */
export function supportContactHref(contact: StoreSupportContact): string | null {
  const rawUrl = contact.url?.trim()
  if (rawUrl) return rawUrl

  const v = contact.value?.trim() ?? ''
  switch (contact.contact_type) {
    case 'phone': {
      const d = digitsOnly(v)
      return d ? `tel:${d}` : `tel:${encodeURIComponent(v)}`
    }
    case 'email':
      return v ? `mailto:${v}` : null
    case 'whatsapp': {
      const d = digitsOnly(v)
      return d ? `https://wa.me/${d}` : null
    }
    case 'telegram': {
      const h = v.replace(/^@+/, '').trim()
      return h ? `https://t.me/${h}` : null
    }
    case 'instagram': {
      const h = v.replace(/^@+/, '').trim()
      return h ? `https://www.instagram.com/${h}/` : null
    }
    case 'other':
    default:
      return null
  }
}

export function groupSupportContactsByLabel(contacts: StoreSupportContact[]): StoreSupportContact[][] {
  const result: StoreSupportContact[][] = []
  const byLabel = new Map<string, StoreSupportContact[]>()

  for (const c of contacts) {
    const lab = (c.label ?? '').trim()
    if (!lab) {
      result.push([c])
      continue
    }
    if (!byLabel.has(lab)) {
      const bucket: StoreSupportContact[] = []
      byLabel.set(lab, bucket)
      result.push(bucket)
    }
    byLabel.get(lab)!.push(c)
  }

  return result
}
